import { useNavigate } from 'react-router-dom'
import { Auth0LoginButton } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserPasswordsetupValidateComponent` (initial
// password setup after an admin-created account, audit §6.3). Owner
// decision 2026-09-26: `PATCH /user/password/validate` is retired — an old
// emailed password-setup link landing here can no longer be completed. Kept
// registered and points at Auth0 sign-in/signup.
export function PasswordSetupValidatePage() {
  const navigate = useNavigate()
  return (
    <div className="portal-card portal-card--notice">
      <p role="alert">
        This account-setup link is no longer valid — set up your account by
        signing in.
      </p>
      <Auth0LoginButton
        popupUrl={AUTH0_LOGIN_URL}
        expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
        onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
      >
        Log in
      </Auth0LoginButton>
    </div>
  )
}
